import { render, staticRenderFns } from "./new-association.vue?vue&type=template&id=599b571c&scoped=true&"
import script from "./new-association.vue?vue&type=script&lang=js&"
export * from "./new-association.vue?vue&type=script&lang=js&"
import style0 from "./new-association.vue?vue&type=style&index=0&id=599b571c&scoped=true&lang=css&"
import style1 from "./new-association.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599b571c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
